import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["fill", "size", "viewBox", "style", "children"];
import React from 'react';
var SizePresets = {
  xsmall: 8,
  small: 12,
  medium: 16,
  large: 20,
  xlarge: 30
};
export function SVGIcon(_ref) {
  var fill = _ref.fill,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    viewBox = _ref.viewBox,
    style = _ref.style,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  // eslint-disable-next-line no-prototype-builtins
  if (SizePresets.hasOwnProperty(size)) {
    size = SizePresets[size];
  }
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet",
    width: size,
    height: size,
    viewBox: viewBox
  }, props, {
    style: _extends({
      color: fill
    }, style)
  }), children);
}